import React, { useState, useEffect } from 'react';
import config from '../../config';
import { Link } from "react-router-dom";
import '../../generalPages/generalCSS/thankyou.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import {
  getBookingDetailsByTransactionId,
  insertBookingDetailsForWebhook,
  insertVehicleBookingDetailsForWebhook
} from "../../Action/user.action";
import Cookies from "js-cookie";

const PaymentSuccess = () => {
  const [isSuccess, setIsSuccess] = useState(null); // null | true | false

  useEffect(() => {
    const processPayment = async () => {
      try {
        /* ---------- 1. Get token ---------- */
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (!token) {
          setIsSuccess(false);
          return;
        }

        localStorage.setItem("responseTokenMMG", token);
        Cookies.set("responseTokenMMG", token);

        /* ---------- 2. Get TEMP Booking Details ---------- */
        const bookingRes = await getBookingDetailsByTransactionId({
          paymentResponse: token
        });

        if (!bookingRes?.success || !bookingRes?.data) {
          setIsSuccess(false);
          return;
        }

        const bookingDetails = bookingRes.data.bookingDetails
          ? typeof bookingRes.data.bookingDetails === "string"
            ? JSON.parse(bookingRes.data.bookingDetails)
            : bookingRes.data.bookingDetails
          : bookingRes.data;

        /* ---------- 3. Call Proper Webhook ---------- */
        let finalRes;

        if (bookingDetails.propertyId) {
          // PROPERTY BOOKING
          finalRes = await insertBookingDetailsForWebhook({
            paymentResponse: token
          });
        }
        else if (bookingDetails.vehicleId) {
          // VEHICLE BOOKING
          finalRes = await insertVehicleBookingDetailsForWebhook({
            paymentResponse: token
          });
        }
        else {
          setIsSuccess(false);
          return;
        }

        /* ---------- 4. Final Result ---------- */
        if (finalRes?.success) {
          localStorage.removeItem("PropertyDetails");
          localStorage.removeItem("vehicleDetails");
          setIsSuccess(true);
        } else {
          setIsSuccess(false);
        }

      } catch (error) {
        console.error("Payment processing error:", error);
        setIsSuccess(false);
      }
    };

    processPayment();
  }, []);

  return (
    <>
      <section className="thankyou-section pt-5 pb-5 overflow-hidden vh-80">
        <Container>
          <Row className='justify-content-center'>
            <Col xl={9} lg={9}>
              <div className="thankyou">
                <div className="text-center">
                  <div className="login-logo mb-5">
                    <img src="assets/images/logo/logo.webp" alt="logo" />
                  </div>

                  <div className='pt-4 pb-4'>
                    
                      <>
                        <h3 className='mb-4'>
                          <b style={{ color: 'blue' }}>Success!!</b>
                        </h3>
                        <p className='mb-4 text-grey'>
                          Your payment has been completed successfully.
                        </p>
                      </>
                

                    {isSuccess !== null && (
                      <Link to={`${config.baseurl}`}>
                        <Button variant='primary'>Return to Home</Button>
                      </Link>
                    )}
                  </div>

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <footer>
        <div className='banner-bottom'>
          <img
            src='assets/images/background/bottom_banner.webp'
            width="100%"
            alt="footer"
          />
        </div>
      </footer>
    </>
  );
};

export default PaymentSuccess;
